import get from 'lodash.get';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectBatchRows = (state) => get(state, 'batchRows', emptyArray);
export const selectSelectedBatches = (state) => get(state, 'selectedBatches', emptyArray);
export const selectIsLoading = (state) => get(state, 'isLoading', true);
export const selectGridSortBy = (state) => get(state, 'sortBy', '');
export const selectGridSearchTerm = (state) => get(state, 'searchTerm', '');
